import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_EMPLOYEE_BID_DATE_TYPE,
  DEFAULT_EMPLOYEE_BID_STATUS_FILTERS,
  DEFAULT_EMPLOYEE_BID_WORKGROUP_FILTERS,
  DEFAULT_EMPLOYEE_BID_SORT_MODEL,
} from "../../util/bid/filterBids";

const initialState = {
  dateTypeFilter: DEFAULT_EMPLOYEE_BID_DATE_TYPE,
  startDateFilter: null,
  endDateFilter: null,
  bidTypeFilters: [],
  statusFilters: DEFAULT_EMPLOYEE_BID_STATUS_FILTERS,
  workgroupFilters: DEFAULT_EMPLOYEE_BID_WORKGROUP_FILTERS,
  searchString: "",
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  sortModel: DEFAULT_EMPLOYEE_BID_SORT_MODEL,
  mobileSortByValue: "Status",
};

export const employeeBidSlice = createSlice({
  name: "employeeBid",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateBidTypeFilters: (state, action) => {
      state.bidTypeFilters = action.payload;
    },
    updateStatusFilters: (state, action) => {
      state.statusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    updateMobileSortByValue: (state, action) => {
      state.mobileSortByValue = action.payload;
    },
    clearAllEmployeeBidFilters: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateBidTypeFilters,
  updateStatusFilters,
  updateSearchString,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  updateMobileSortByValue,
  clearAllEmployeeBidFilters,
} = employeeBidSlice.actions;

export const selectEmployeeBidData = (state) => state.employeeBid;

export default employeeBidSlice.reducer;
